export default "__VITE_ASSET__o2Xcmj0n__"